"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.setCachedOfferQueryVariables = exports.selectedFiltersToQuery = exports.selectedFiltersToGraphQLVariables = exports.selectedFiltersFromQuery = exports.isOfferTypeFilter = exports.isFilterTypeText = exports.isFilterTypeMultiple = exports.hasFilterMultipleValue = exports.getVehicleDisclaimer = exports.getTitle = exports.getSelectedFilterKeysMap = exports.getCachedOfferQueryVariables = exports.convertQueryToGraphQLVariables = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get = _interopRequireDefault(require("lodash/get"));
var _offersV = require("./offers-v3.config");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var OFFER_QUERY_PARAMS_CACHE_KEY = 'mmc_offr_query_params';
var localStorage = typeof window !== 'undefined' && window.localStorage;
var isOfferTypeFilter = function isOfferTypeFilter(key) {
  return key === _offersV.filtersMap.OFFER_TYPE;
};
exports.isOfferTypeFilter = isOfferTypeFilter;
var isFilterTypeMultiple = function isFilterTypeMultiple(type) {
  return type === _offersV.filtersType.MULTIPLE;
};
exports.isFilterTypeMultiple = isFilterTypeMultiple;
var isFilterTypeText = function isFilterTypeText(type) {
  return type === _offersV.filtersType.TEXT;
};
exports.isFilterTypeText = isFilterTypeText;
var hasFilterMultipleValue = function hasFilterMultipleValue(value) {
  return typeof value !== 'string';
};
exports.hasFilterMultipleValue = hasFilterMultipleValue;
var getSelectedFilterKeysMap = function getSelectedFilterKeysMap(selectedFilter) {
  if (!selectedFilter) {
    return {};
  }
  return Object.entries(selectedFilter).reduce(function (keysMap, _ref) {
    var _objectSpread2;
    var key = _ref[0],
      value = _ref[1];
    return value ? _objectSpread(_objectSpread({}, keysMap), {}, (_objectSpread2 = {}, _objectSpread2[key] = value, _objectSpread2)) : keysMap;
  }, {});
};
exports.getSelectedFilterKeysMap = getSelectedFilterKeysMap;
var getTitle = function getTitle(_ref2) {
  var data = _ref2.data,
    queryVariables = _ref2.queryVariables,
    defaultTitle = _ref2.defaultTitle;
  if (!data) {
    return defaultTitle;
  }
  var _ref3 = data || {},
    getOfferV3ListByFilter = _ref3.getOfferV3ListByFilter;
  var _ref4 = getOfferV3ListByFilter || {},
    offerLabel = _ref4.offerLabel;
  var _ref5 = offerLabel || {},
    seeOffersLabel = _ref5.seeOffersLabel,
    seeOffersForVehiclesLabel = _ref5.seeOffersForVehiclesLabel,
    seeOffersNearZipCodeLabel = _ref5.seeOffersNearZipCodeLabel,
    seeOffersForVehiclesNearZipCodeLabel = _ref5.seeOffersForVehiclesNearZipCodeLabel;
  var vehicles = queryVariables.vehicles,
    zipCode = queryVariables.zipCode;
  if (!vehicles && zipCode) return seeOffersNearZipCodeLabel;
  if (vehicles && vehicles.length && !zipCode) return seeOffersForVehiclesLabel;
  if (vehicles && vehicles.length && zipCode) return seeOffersForVehiclesNearZipCodeLabel;
  return seeOffersLabel;
};
exports.getTitle = getTitle;
var getValueFromQueryParams = function getValueFromQueryParams(filter, queryParamValue) {
  var value = queryParamValue;
  if (!value) {
    return filter.defaultValue;
  }
  if (hasFilterMultipleValue(filter.defaultValue)) {
    var values = value.split(',');
    var valuesMap = values.reduce(function (map, key) {
      var _objectSpread3;
      return _objectSpread(_objectSpread({}, map), {}, (_objectSpread3 = {}, _objectSpread3[key] = true, _objectSpread3));
    }, {});
    if (isOfferTypeFilter(filter.key)) {
      return filter.options.reduce(function (offersTypeValue, option) {
        var _objectSpread4;
        var checked = valuesMap[option.id];
        return checked ? _objectSpread(_objectSpread({}, offersTypeValue), {}, (_objectSpread4 = {}, _objectSpread4[option.name] = true, _objectSpread4)) : offersTypeValue;
      }, filter.defaultValue);
    }
    return _objectSpread(_objectSpread({}, filter.defaultValue), valuesMap);
  }
  return value;
};
var selectedFiltersFromQuery = function selectedFiltersFromQuery(filters, queryParams) {
  var c = filters.reduce(function (selectedFilters, filter) {
    var _objectSpread5;
    return _objectSpread(_objectSpread({}, selectedFilters), {}, (_objectSpread5 = {}, _objectSpread5[filter.key] = getValueFromQueryParams(filter, queryParams[filter.key]), _objectSpread5));
  }, {});
  return c;
};
exports.selectedFiltersFromQuery = selectedFiltersFromQuery;
var selectedFiltersToArray = function selectedFiltersToArray(selectedFilters, filters, transformers) {
  if (transformers === void 0) {
    transformers = {};
  }
  return filters.reduce(function (query, filter) {
    var selectedValue = selectedFilters[filter.key];
    var transformTypeMultiple = transformers.typeMultiple || function (v) {
      return v;
    };
    var transformTypeSingle = transformers.typeSingle || function (v) {
      return v;
    };
    if (typeof selectedValue !== 'undefined') {
      var _objectSpread6;
      var getMultipleValue = function getMultipleValue() {
        return filter.options.reduce(function (acc, option) {
          return [].concat(acc, [selectedValue[option.name] ? option.queryValue : false]);
        }, []).filter(Boolean);
      };
      var queryValue = isFilterTypeMultiple(filter.type) ? transformTypeMultiple(getMultipleValue(), filter) : transformTypeSingle(selectedValue, filter);
      return _objectSpread(_objectSpread({}, query), {}, (_objectSpread6 = {}, _objectSpread6[filter.key] = queryValue, _objectSpread6));
    }
    return query;
  }, {});
};
var selectedFiltersToQuery = function selectedFiltersToQuery(selectedFilters, filters, filterKey) {
  var out = {};
  Object.keys(selectedFilters).forEach(function (key) {
    out[key] = selectedFilters[key];
  });
  var query = selectedFiltersToArray(out, filters, {
    typeMultiple: function typeMultiple(v) {
      return v.join(',');
    }
  });
  return query;
};
exports.selectedFiltersToQuery = selectedFiltersToQuery;
var isUTM = function isUTM(queryParam) {
  for (var filter in _offersV.filtersMap) {
    if (_offersV.filtersMap[filter] === queryParam) {
      return false;
    }
  }
  return true;
};
var convertQueryToGraphQLVariables = function convertQueryToGraphQLVariables(query, filters) {
  var variables = {};
  Object.keys(query).forEach(function (key) {
    if (key === 'datasetName') {
      variables[key] = query[key];
      return;
    }
    if (isUTM(key)) return;
    var target = filters.find(function (filter) {
      return filter.key === key;
    });
    if (target) {
      var keyType = target.type;
      var newKey = key === 'provinceMapList' ? 'zipCode' : key;
      var value = ['zipCode', 'region'].includes(key) ? [query[key]] // as backend expects zipCode value to be an array
      : query[key];
      variables[newKey] = keyType === 'multiple' ? query[key].split(',') : value;
    }
  });
  return variables;
};
exports.convertQueryToGraphQLVariables = convertQueryToGraphQLVariables;
var selectedFiltersToGraphQLVariables = function selectedFiltersToGraphQLVariables(selectedFilters, filters) {
  var variables = selectedFiltersToArray(selectedFilters, filters, {
    typeMultiple: function typeMultiple(value) {
      return (
        // undefined resets the value in GraphQL
        // giving the default offers list
        value.length ? value : undefined
      );
    }
  });
  return variables;
};
exports.selectedFiltersToGraphQLVariables = selectedFiltersToGraphQLVariables;
var getVehicleDisclaimer = function getVehicleDisclaimer(vehicle) {
  return (0, _get["default"])(vehicle, 'offers[0].legalTextImage');
};
exports.getVehicleDisclaimer = getVehicleDisclaimer;
var getCachedOfferQueryVariables = function getCachedOfferQueryVariables() {
  if (!localStorage || !localStorage.getItem(OFFER_QUERY_PARAMS_CACHE_KEY)) {
    return {};
  }
  return JSON.parse(localStorage.getItem(OFFER_QUERY_PARAMS_CACHE_KEY));
};
exports.getCachedOfferQueryVariables = getCachedOfferQueryVariables;
var setCachedOfferQueryVariables = function setCachedOfferQueryVariables(data) {
  if (!localStorage) {
    return;
  }
  if (data) {
    localStorage.setItem(OFFER_QUERY_PARAMS_CACHE_KEY, JSON.stringify(data));
  }
};
exports.setCachedOfferQueryVariables = setCachedOfferQueryVariables;